import React from 'react';
import { Box, Typography } from '@mui/material';
import { useCampaign } from '../contexts/CampaignContext';

// Height of the bar, shared with Navbar (top offset) and PageLayout (content
// margin) so the bar sits above the header and pushes the whole site down.
// The offset is only applied when the strip is actually visible (see Navbar /
// PageLayout, which read `stripVisible` and collapse to 0 when there's no strip).
export const ANNOUNCEMENT_BAR_HEIGHT = 40;

// Site-wide top strip driven by the resolved campaign for the current page.
// Renders nothing when there's no strip. When `ctaUrl` is set the whole strip
// links out (new tab); otherwise it's plain, non-clickable text.
const AnnouncementBar = () => {
  const { strip } = useCampaign();

  if (!strip) {
    return null;
  }

  const ctaUrl = strip.ctaUrl;
  const message = strip.message;
  const isLink = !!ctaUrl;

  return (
    <Box
      component={isLink ? 'a' : 'div'}
      href={isLink ? ctaUrl : undefined}
      target={isLink ? '_blank' : undefined}
      rel={isLink ? 'noopener noreferrer' : undefined}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: ANNOUNCEMENT_BAR_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        bgcolor: '#000000',
        color: '#ffffff',
        textAlign: 'center',
        textDecoration: 'none',
        cursor: isLink ? 'pointer' : 'default',
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
    >
      <Typography sx={{ fontWeight: 600, letterSpacing: 0.3, lineHeight: 1.15, fontSize: { xs: '0.72rem', sm: '0.85rem' } }}>
        {message}
      </Typography>
    </Box>
  );
};

export default AnnouncementBar;
